import { loginApi, logoutApi, bindGoogleAutApi } from "@/api/auth";
import { getUserInfoApi } from "@/api/system/user";
import { resetRouter } from "@/router";
import { store } from "@/store";

import { GoogleBindForm, LoginApiResult, LoginData, LoginResult } from "@/api/auth/types";
import { UserInfo } from "@/api/system/user/types";

export const useUserStore = defineStore("user", () => {
  const user: UserInfo = {
    roles: [],
    perms: [],
  };

  /**
   * 保存登录凭证
   */
  function saveToken(loginResult: LoginResult) {
    const { accessToken } = loginResult;
    localStorage.setItem("accessToken", String("Bearer" + " " + accessToken));
  }

  /**
   * 登录
   *
   * 未绑定谷歌验证码时后端返回 code=G0001，data 为二维码绑定信息，
   * 此时不保存 token，由调用方(登录页)引导用户扫码绑定
   *
   * @param {LoginData}
   * @returns
   */
  function login(loginData: LoginData) {
    return new Promise<LoginApiResult>((resolve, reject) => {
      loginApi(loginData)
        .then((res) => {
          if (res.code !== "G0001") {
            saveToken(res.data as LoginResult);
          }
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  /**
   * 绑定激活谷歌验证码
   *
   * 绑定成功即返回登录结果，保存 token 完成登录
   *
   * @param {GoogleBindForm}
   * @returns
   */
  function bindGoogleAut(form: GoogleBindForm) {
    return new Promise<void>((resolve, reject) => {
      bindGoogleAutApi(form)
        .then((res) => {
          saveToken(res.data as LoginResult);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  // 获取信息(用户昵称、头像、角色集合、权限集合)
  function getUserInfo() {
    return new Promise<UserInfo>((resolve, reject) => {
      getUserInfoApi()
        .then(({ data }) => {
          if (!data) {
            reject("Verification failed, please Login again.");
            return;
          }
          if (!data.roles || data.roles.length <= 0) {
            reject("getUserInfo: roles must be a non-null array!");
            return;
          }
          Object.assign(user, { ...data });
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  // user logout
  function logout() {
    return new Promise<void>((resolve, reject) => {
      logoutApi()
        .then(() => {
          localStorage.setItem("accessToken", "");
          location.reload(); // 清空路由
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  // remove token
  function resetToken() {
    return new Promise<void>((resolve) => {
      localStorage.setItem("accessToken", "");
      resetRouter();
      resolve();
    });
  }

  return {
    user,
    login,
    bindGoogleAut,
    getUserInfo,
    logout,
    resetToken,
  };
});

// 非setup
export function useUserStoreHook() {
  return useUserStore(store);
}
